import { Routes, Route, Navigate } from "react-router-dom";
import PageTemplate from "../components/PageTemplate";
import RSVPSearch from "./RSVPSearch";
import RSVPGroups from "./RSVPGroups";
import RSVPForm from "./RSVPForm";
import RSVPFinished from "./RVSPFinished";
import Content from "../components/Content";
import { useState, useEffect } from 'react'
import { useLocation } from "react-router-dom";
import PageFade from "../motions/PageFade";

function RSVP() {

    const [allGuests, setAllGuests] = useState([]);
    const [allResponses, setAllResponses] = useState([]);
    const [rsvpGroups, setRsvpGroups] = useState([])
    const [selectedRSVP, setSelectedRSVP] = useState(null)
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const location = useLocation();
    const path = location.pathname;

    useEffect(() => {
        fetchData();
    }, []);

    async function fetchData() {
        try {
            const [guestsRes, responsesRes] = await Promise.all([
                fetch("https://wedding-website-backend-nu.vercel.app/api/guests"),
                fetch("https://wedding-website-backend-nu.vercel.app/api/responses"),
            ]);

            if (!guestsRes.ok || !responsesRes.ok) {
                throw new Error(
                    `HTTP error! guests: ${guestsRes.status}, responses: ${responsesRes.status}`
                );
            }

            const [guestsData, responsesData] = await Promise.all([
                guestsRes.json(),
                responsesRes.json(),
            ]);

            guestsData.guests = guestsData.guests.filter(
                guest => guest.name !== "Thuyan Duong" && guest.name !== "Jerry Lee"
            )
            setAllGuests(guestsData.guests);
            setAllResponses(responsesData.responses);
        } catch (err) {
            setError(true);
        } finally {
            setLoading(false);
        }
    }

    return (
        <PageFade>
            <PageTemplate title="Join Us in Celebrating!" textColor="text-bronze" bgColor="bg-blush">
                <Content>
                    <Routes>
                        <Route index element={
                            <div className="text-center">
                                <p>Thank you so much for your love and support!</p>
                                <p>RSVPs are now closed.</p>
                                <p>If you need to make any changes, please reach out to Thuyan and Jerry directly.</p>
                            </div>
                        } />
                        {/* <Route path="search" element={<RSVPSearch
                            allGuests={allGuests}
                            allResponses={allResponses}
                            setRsvpGroups={setRsvpGroups}
                            error={error}
                            loading={loading}                                
                        />}/> */}
                        <Route path="groups" element={<RSVPGroups
                            rsvpGroups={rsvpGroups}
                            setRsvpGroups={setRsvpGroups}
                            setSelectedRSVP={setSelectedRSVP}
                            allResponses={allResponses}
                            error={error}
                        />} />
                        <Route path="form" element={<RSVPForm
                            selectedRSVP={selectedRSVP}
                            setSelectedRSVP={setSelectedRSVP}
                            allResponses={allResponses}
                            error={error}
                        />} />
                        <Route path="finished" element={<RSVPFinished
                        />} />
                        <Route path="*" element={<Navigate to="/rsvp" replace />} />
                    </Routes>
                </Content>
            </PageTemplate>
        </PageFade>
    );
}

// function RSVP() {
//     return (
//         <PageTemplate title="RSVP" textColor="text-bronze" bgColor="bg-blush">
//             <div className="text-center">
//                 <p>Thank you so much for your love and support!</p>
//                 <p>RSVPs are now closed.</p>
//                 <p>If you need to make any changes, please reach out to Thuyan and Jerry directly.</p>
//             </div>
//         </PageTemplate>
//     )
// return (
//     <PageTemplate title="RSVP" textColor="text-bronze" bgColor="bg-blush">
//         <div className="text-center">
//             <p>We’re so excited to celebrate with you! </p>
//             <p>Wedding invitations will go out in early 2026 to everyone who received a Save-the-Date.</p>
//             <p>RSVPs will open shortly afterwards.</p>
//         </div>
//     </PageTemplate>
//     // );
// }

export default RSVP;
